import { scriptExists } from './scriptExists';

export function loadTalkable(response) {
  //console.log(response);
  const email = response && response.user ? response.user.email : '';
  const firstName = response && response.user ? response.user.firstName : '';
  const lastName = response && response.user ? response.user.lastName : '';
  const roles = response && response.roles ? response.roles.join() : '';
  // $sql = "SELECT {$type} FROM shop_user_id_segments WHERE user_id = {$userID} ORDER BY id DESC LIMIT 1"
  const userSegment = '';
  //FFFUtils.readCookie('popupFlow')
  const otherPopups = '';
  if (!document.getElementById('talkable-script-id')) {
    const talkableScript = document.createElement('script');
    const inlineScript = document.createTextNode(`${`${`${`${`${`${`${'window._talkableq = window._talkableq || [];\n'
      + '  _talkableq.push([\'init\', { site_id: "'}${process.env.REACT_APP_TALKABLE_SITE_ID}" }]);\n`
      + '\n'
      + '  window._talkableq.push([\'authenticate_customer\', {\n'
      + '    email: "'}${email}", \n`
      + '    first_name: "'}${firstName}", \n`
      + '    last_name: "'}${lastName}", \n`
      + '    person_custom_properties: {\n'
      + '                               plan_code: "'}${roles}", \n`
      + '                               user_segment: "'}${userSegment}", \n`
      + '                               other_popups: "'}${otherPopups}" \n`
      + '    } \n' // info to fine tune post purchase campaign
      + '  }]);\n'
      + '\n'
      + '  window._talkableq.push([\'register_affiliate\', {}]);');
    talkableScript.appendChild(inlineScript);
    talkableScript.type = 'text/javascript';
    talkableScript.id = 'talkable-script-id';

    document.head.appendChild(talkableScript);
  }

  const scriptSrc = process.env.REACT_APP_TALKABLE_SCRIPT_URL;
  if (!scriptExists(scriptSrc)) {
    const blockScript = document.createElement('script');
    blockScript.src = scriptSrc;
    blockScript.async = true;
    blockScript.type = 'text/javascript';
    document.head.appendChild(blockScript);
  }
}
